export default function CategoryPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>分类页面建设中...</p>
    </div>
  );
}